'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  height: 24px;\n'], ['\n  height: 24px;\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: 10px;\n  margin-right: 2px;\n  margin-left: 2px;\n  margin-bottom: 2px;\n\n  text-align: left;\n'], ['\n  margin-top: 10px;\n  margin-right: 2px;\n  margin-left: 2px;\n  margin-bottom: 2px;\n\n  text-align: left;\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);\n  padding: 8px;\n  width: 200px;\n  height: auto;\n  max-height: 225px;\n  overflow: scroll;\n  position: absolute;\n  right: -10px;\n  top: 4px;\n  z-index: 1;\n'], ['\n  background-color: ', ';\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);\n  padding: 8px;\n  width: 200px;\n  height: auto;\n  max-height: 225px;\n  overflow: scroll;\n  position: absolute;\n  right: -10px;\n  top: 4px;\n  z-index: 1;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _XactlyColors = require('../../themes/XactlyColors');
var _XactlyColors2 = _interopRequireDefault(_XactlyColors);
var _SearchBox = require('../SearchBox');
var _CheckBoxGroup = require('../CheckBoxGroup');
var _CheckBox = require('../CheckBox');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledSearchBox = (0, _styledComponents2['default'])(_SearchBox.SearchBox)(_templateObject);
var StyledCheckBoxGroup = (0, _styledComponents2['default'])(_CheckBoxGroup.CheckBoxGroup)(_templateObject2);
var FilterContainer = _styledComponents2['default'].div.withConfig({
  displayName: 'FilterDropdown__FilterContainer',
  componentId: 'xcsi10-0'
})(_templateObject3, _XactlyColors2['default'].xPure);
var FilterDropdown = function (_Component) {
  _inherits(FilterDropdown, _Component);
  function FilterDropdown(props) {
    _classCallCheck(this, FilterDropdown);
    var _this = _possibleConstructorReturn(this, (FilterDropdown.__proto__ || Object.getPrototypeOf(FilterDropdown)).call(this, props));
    _this.state = {
      searchValue: ''
    };
    _this.filterRef = null;
    _this.setFilterRef = function (element) {
      _this.filterRef = element;
    };
    _this.searchHandler = _this.searchHandler.bind(_this);
    _this.handleClickOutsideFilter = _this.handleClickOutsideFilter.bind(_this);
    return _this;
  }
  _createClass(FilterDropdown, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        document.addEventListener('click', this.handleClickOutsideFilter);
      }
      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutsideFilter);
      }
      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var className = this.props.className;
        return _react2['default'].createElement(FilterContainer, {
          className: className,
          innerRef: this.setFilterRef
        }, _react2['default'].createElement(StyledSearchBox, {
          debounced: true,
          searchHandler: this.searchHandler
        }), this.renderCheckBoxGroup());
      }
      return render;
    }()
  }, {
    key: 'renderCheckBoxGroup',
    value: function () {
      function renderCheckBoxGroup() {
        var _props = this.props,
          filterGroup = _props.filterGroup,
          handleSelection = _props.handleSelection,
          selectedValues = _props.selectedValues;
        return _react2['default'].createElement(StyledCheckBoxGroup, {
          className: 'checkbox-holder',
          changeHandler: handleSelection,
          groupName: filterGroup,
          selectedValues: selectedValues
        }, this.renderCheckBoxes());
      }
      return renderCheckBoxGroup;
    }()
  }, {
    key: 'renderCheckBoxes',
    value: function () {
      function renderCheckBoxes() {
        var searchValue = this.state.searchValue;
        var items = this.props.items;
        var filteredItems = items;
        if (searchValue.length > 0) {
          filteredItems = items.filter(function (item) {
            return item.name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
          });
        }
        return filteredItems.map(function (item, index) {
          return _react2['default'].createElement(_CheckBox.CheckBox, {
            key: index,
            label: item.name,
            value: item.value
          });
        });
      }
      return renderCheckBoxes;
    }()
  }, {
    key: 'searchHandler',
    value: function () {
      function searchHandler(searchValue) {
        this.setState({
          searchValue: searchValue
        });
      }
      return searchHandler;
    }()
  }, {
    key: 'handleClickOutsideFilter',
    value: function () {
      function handleClickOutsideFilter(event) {
        var filterClickHandler = this.props.filterClickHandler;
        if (!this.filterRef.contains(event.target)) {
          filterClickHandler(null, true);
        }
      }
      return handleClickOutsideFilter;
    }()
  }]);
  return FilterDropdown;
}(_react.Component);
FilterDropdown.defaultProps = {
  filterClickHandler: function () {
    function filterClickHandler() {}
    return filterClickHandler;
  }()
};
FilterDropdown.propTypes = {
  items: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
    name: _propTypes2['default'].string.isRequired,
    value: _propTypes2['default'].string.isRequired
  })).isRequired,
  filterGroup: _propTypes2['default'].string.isRequired,
  filterClickHandler: _propTypes2['default'].func,
  handleSelection: _propTypes2['default'].func.isRequired,
  selectedValues: _propTypes2['default'].arrayOf(_propTypes2['default'].string).isRequired
};
FilterDropdown.displayName = 'DataTable-FilterDropdown';
exports['default'] = FilterDropdown;